import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo-TAD-d.png";
import { formatNumber } from "../../funciones/GeneralFunctions";

class PlanillaInscripcion extends Component {
    contenido = (tipo) => {
        const stylesAdm = StyleSheet.create(ADMISION[0]);
        let { data, dataInscripcion, tipoInsc, periodo, dataEst, creditos, monto, inscripcion, cuotaN, cuotas, qr } = this.props;

        let dato = (dat) => {
            let str = dat;
            if (dat === null) str = "";
            return str;
        }

        let materiasInsc = () => {
            
            return (
                data.map(option => (
                    <View key={option[0]} style={[stylesAdm.row]}>
                        <Text style={[stylesAdm.colTabla1, stylesAdm.font8, stylesAdm.bordeCol11]}>{option[1].materia}</Text>
                        <Text style={[stylesAdm.colTabla2, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[1].seccion}</Text>
                        <Text style={[stylesAdm.colTabla3, stylesAdm.font6, stylesAdm.bordeCol9, stylesAdm.center]}>{option[1].tipoM.label}</Text>
                        <Text style={[stylesAdm.colTabla3, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[4].label}</Text>
                        <Text style={[stylesAdm.colTabla4_c, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[2]}</Text>
                        <Text style={[stylesAdm.colTabla3_c, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{`${formatNumber(option[3])}`}</Text>
                    </View>
                ))
            )
        }

        let itemsFactura = (num, item, monto) => (
            <View style={[stylesAdm.row]}>
                <Text style={[stylesAdm.colTabla6, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>{num}</Text>
                <Text style={[stylesAdm.colTabla7_c, stylesAdm.font8, stylesAdm.bordeCol11]}>{item}</Text>
                <Text style={[stylesAdm.colTabla8_c, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>{monto}</Text>
            </View>
        )

        return (
            <React.Fragment>
                <View style={stylesAdm.row}>
                    <Image
                        style={[stylesAdm.colContent40, stylesAdm.logo]}
                        src={logo}
                    />
                    <View style={[stylesAdm.colContent60, stylesAdm.header1Left,{marginTop: 14,}]}>
                        <Text style={[stylesAdm.Negrita]}>TEACHER AT DOOR</Text>
                        <Text style={[stylesAdm.textPeq]}>Clases de Inglés personalizadas</Text>
                    </View>
                    <Text style={[stylesAdm.token]}>N° - {(dataInscripcion.token).substring(0,10)}</Text>
                </View>
                <Text style={[stylesAdm.titulo, stylesAdm.header1Right, stylesAdm.custonMt10, stylesAdm.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    PLANILLA DE INSCRIPCIÓN{/* tipoInsc */}
                </Text>

                <View style={[stylesAdm.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DE LA SOLICITUD</Text>
                    <View style={[stylesAdm.row, {padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.col6]}>
                            <View style={[stylesAdm.row]}>
                                <Text style={[stylesAdm.col3, stylesAdm.font10]}>Periodo: {periodo}</Text>
                                <Text style={[stylesAdm.col3, stylesAdm.font10, {textAlign: "right"}]}>{/* Carrera: {dataEst.carrera} */}</Text>
                            </View>
                            <View style={[stylesAdm.row]}>
                                <Text style={[stylesAdm.col3, stylesAdm.font10]}>Fecha de la solicitud: {dataInscripcion.solicitud}</Text>
                                <Text style={[stylesAdm.col3, stylesAdm.font10, {textAlign: "right", color: "#c60000"}]}>Debes asistir a formalizar tu inscripción el dia: {dataInscripcion.cita}</Text>
                            </View>
                            <View style={[stylesAdm.row, {marginTop: 5}]}>
                                <Text style={[stylesAdm.col6, stylesAdm.font6, {textAlign: "justify"}]}>
                                    Importante: Si no asistes en la fecha pautada, tu solicitud de inscripción será rechazada automáticamente por el sistema y deberás realizar el proceso nuevamente
                                </Text>
                                {/* <Text style={[stylesAdm.col6, stylesAdm.font8, {textAlign: "justify", color: "#c60000"}]}>
                                    Importante: Debido a la cuarentena, no es necesario que acudas a la institución el dia de la cita pero si debes cancelar los aranceles antes de esa fecha
                                </Text> */}
                            </View>
                        </View>
                    </View>
                </View>

                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>II. DATOS DEL ESTUDIANTE</Text>
                    <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col2, stylesAdm.font9]}>Cédula de Identidad: {`${dataEst.nacionalidad} ${dataEst.cedula}`}</Text>
                            <Text style={[stylesAdm.col4, stylesAdm.font9, {textAlign: "right"}]}>Nombres y Apellidos: {`${dataEst.nombre1} ${dato(dataEst.nombre2)} ${dataEst.apellido1} ${dato(dataEst.apellido2)}`}</Text>
                        </View>
                    </View>
                </View>

                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>III. DETALLES DE LA INSCRIPCIÓN</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla1, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF"}]}>Materia</Text>
                            <Text style={[stylesAdm.colTabla2, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Sección</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Modalidad</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Semestre</Text>
                            <Text style={[stylesAdm.colTabla4_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>U.C.</Text>
                            <Text style={[stylesAdm.colTabla3_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Monto en Bs.</Text>
                        </View>
                        {materiasInsc()}
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla5, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'right'}]}>Totales</Text>
                            <Text style={[stylesAdm.colTabla4_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{creditos}</Text>
                            <Text style={[stylesAdm.colTabla3_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{formatNumber(monto)} Bs.</Text>
                        </View>
                        <View style={[stylesAdm.row, {paddingRight: 5, marginTop: 3}]}>
                            <Text style={[stylesAdm.font7, {color: "#c60000"}]}>IMPORTANTE: El Total en Bs. de las materias corresponde al valor actual de la Unidad de Crédito por lo que puede variar en cada cuota. El monto es solo referencial</Text>
                        </View>
                    </View>
                    <Text style={[stylesAdm.font10, {marginTop: 10, backgroundColor: "#ccc"}]}>IV. DETALLES DE FACTURACIÓN</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff",}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla6, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'center'}]}>N°</Text>
                            <Text style={[stylesAdm.colTabla7_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF"}]}>Descripción</Text>
                            <Text style={[stylesAdm.colTabla8_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Precio en Bs.</Text>
                        </View>
                        {itemsFactura(1, tipoInsc, formatNumber(parseFloat(inscripcion)))}
                        {itemsFactura(2, cuotaN, `${formatNumber((monto/* /cuotas */))}`)}
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla9_c, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'right'}]}>TOTAL A PAGAR</Text>
                            <Text style={[stylesAdm.colTabla8_c, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{formatNumber((parseFloat(inscripcion) + (monto/* /cuotas */)))} Bs.</Text>
                        </View>
                    </View>
                </View>
                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>V. PARA SER LLENADO EN LA INSTITUCIÓN</Text>
                    <View style={{padding: 5, backgroundColor: "#fff"}}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col3, stylesAdm.font7, stylesAdm.bordeCol11, stylesAdm.borderTop, {borderBottom: 0}]}>OBSERVACIONES:</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.borderTop, {borderBottom: 0}]}>ADMINISTRACION</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.borderTop, {borderBottom: 0}]}>CTROL. DE ESTUDIOS</Text>
                        </View>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col3, stylesAdm.font7, stylesAdm.bordeCol11, {height: 70}]}></Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.center, {height: 70, paddingTop: 25}]}>FIRMA Y SELLO</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.center, {height: 70, paddingTop: 25}]}>FIRMA Y SELLO</Text>
                        </View>
                    </View>
                </View>

                <View style={stylesAdm.row}>
                    <Text style={[stylesAdm.tipo, {textAlign: "right", marginTop: 10}]}>{tipo}</Text>
                </View>

                <View style={[stylesAdm.footer2]}>
                    <View style={[stylesAdm.row]}>
                        <View style={[stylesAdm.col9]}>
                            <Text style={[stylesAdm.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar este registro vaya al enlace: https://iudlm.com/validar y coloque el número de la planilla. También puedes escanear el código qr de la derecha.
                            </Text>
                            <Text style={[stylesAdm.linea2]}></Text>
                            <Text style={[stylesAdm.encabezado]}>
                            Sede Chacao | Academia de inglés Venezuela | Multicentro Empresarial del Este, Núcleo A, torre Libertador, piso 17, oficina A-171 Edo Miranda Caracas - Venezuela
                            </Text>
                            <Text style={[stylesAdm.encabezado, {marginTop: -5}]}>
                                Teléfono: +58 (414) 0862068 | Email: administration@tadenglishclass.com
                            </Text>
                        </View>
                        <View style={[stylesAdm.col10]}>
                            <Image
                                style={[stylesAdm.logoQr, {left:20}]}
                                src={qr}
                            />
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() {
        const stylesAdm = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={stylesAdm.section}>
                <Document title="Planilla de Inscripción">
                    <Page size="letter" style={stylesAdm.body}>
                        <View>
                            {this.contenido("ORIGINAL - INSTITUTO")}
                        </View>
                    </Page>
                    <Page size="letter" style={stylesAdm.body}>
                        <View>
                            {this.contenido("COPIA - ESTUDIANTE")}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default PlanillaInscripcion;


// WEBPACK FOOTER //
// ./src/components/Reportes/PlanillaInscripcion.jsx